import { ajax } from "../../app/core/ajax";
import * as z from "../../framework";

export function getNewSortOrder(args) {
    var url = getMaxSortOrderUrl(args);

    return ajax({
        type: "GET",
        url: url
    }).done(function (data) {
        if (data.d.results[0]) {
            args.observable.set(
                args.field ? args.field : "SortOrder",
                data.d.results[0][args.field ? args.field : "SortOrder"] + 1
            );
        } else {
            args.observable.set(args.field ? args.field : "SortOrder", 1);
        }
    });
}

export function getMaxSortOrderUrl(args) {
    var url = `${args.eType}/?$select=${args.field ? args.field : "SortOrder"}&$orderby=${args.field ? args.field : "SortOrder"} desc`;
    if (args.parentType) {
        url = `${url}&$filter=${args.parentType}Id eq ${args.parentId}`;
    }

    if (args.filter) {
        if (url.indexOf("$filter=") != -1) {
            url = `${url} and (${args.filter})`;
        } else {
            url = `${url}&$filter=${args.filter}`
        }
    }

    url = `${url}&$top=1`;

    return url;
}

export async function getUpdatedSortOrders(args) {
    await ajax({
        type: "GET",
        url: `${args.eType}?$select=Id,SortOrder&$filter=SortOrder ge ${args.sortOrder}&$inlinecount=allpages&$top=10000&$orderby=SortOrder`
    }).done(function (data) {
        data.d.results.forEach(code => {
            var cacheIndex = z.codes[args.eType].findIndex(x => x.Id == code.Id);
            if (cacheIndex > -1)
                z.codes[args.eType][cacheIndex].SortOrder = code.SortOrder;
        });
    });
}
